// https://docs.mangopay.com/endpoints/v2.01/kyc-documents#e204_the-kyc-document-object

export enum KycStatus {
  CREATED = 'CREATED',
  VALIDATION_ASKED = 'VALIDATION_ASKED',
  VALIDATED = 'VALIDATED',  
  REFUSED = 'REFUSED', 
  OUT_OF_DATE = 'OUT_OF_DATE'
}

export default {
  KycStatus,
};
